// Bilingual strings + label helpers for the Managed Transportation booking engine.
// Practical Arabic: UI is translated; UAE place names and vehicle model names stay Latin.

const F = (fn) => fn; // marker for function-valued entries

const DICT = {
  docTitle: { en: 'Book Your Journey | Eurogulf Managed Transportation', ar: 'احجز رحلتك | يوروجلف للنقل المُدار' },

  // Service tabs
  svcTransferTitle: { en: 'Airport Transfer / Point-to-Point', ar: 'نقل المطار / من نقطة إلى نقطة' },
  svcTransferDesc: { en: 'Fixed one-way & return fares, all UAE airports', ar: 'أسعار ثابتة للذهاب والعودة، جميع مطارات الإمارات' },
  svcChauffeurTitle: { en: 'Chauffeur by the Hour', ar: 'سائق خاص بالساعة' },
  svcChauffeurDesc: { en: 'Half day (4h) or full day (8h) with a driver', ar: 'نصف يوم (4 ساعات) أو يوم كامل (8 ساعات) مع سائق' },
  svcBusTitle: { en: 'Bus Hire & Group Transfers', ar: 'تأجير الحافلات ونقل المجموعات' },
  svcBusDesc: { en: '12 to 50-seat coaches for groups & staff', ar: 'حافلات من 12 إلى 50 مقعداً للمجموعات والموظفين' },
  termsHeadingBus: { en: 'Bus Hire & Transfer terms', ar: 'شروط تأجير الحافلات والنقل' },
  termsHeadingTransfer: { en: 'Transfer & Chauffeur terms', ar: 'شروط النقل والسائق الخاص' },

  // Hero
  heroChip: { en: 'Managed Transportation', ar: 'النقل المُدار' },
  heroTitle: { en: 'Book your journey with an instant fare.', ar: 'احجز رحلتك مع سعر فوري.' },
  heroSub: { en: 'Airport transfers, hourly chauffeur and group coaches, professionally driven across all seven Emirates, with transparent pricing.', ar: 'نقل المطارات، سائق خاص بالساعة وحافلات المجموعات، بقيادة محترفين في جميع الإمارات السبع، بأسعار شفافة.' },
  heroWhatsapp: { en: 'WhatsApp a specialist', ar: 'راسل مختصاً عبر واتساب' },
  heroCall: { en: 'Call 800 364', ar: 'اتصل 800 364' },

  // Wizard nav
  back: { en: 'Back', ar: 'رجوع' },
  continue: { en: 'Continue', ar: 'متابعة' },
  submitting: { en: 'Submitting...', ar: 'جارٍ الإرسال...' },
  confirmBooking: { en: 'Confirm Booking', ar: 'تأكيد الحجز' },

  // Trust bar
  trustDispatch: { en: 'Dispatch & flight monitoring', ar: 'الإرسال ومتابعة الرحلات' },
  trustLicensed: { en: 'Emirates licensed', ar: 'مرخّصة في الإمارات' },
  trustVehicles: { en: 'Premium vehicles', ar: 'مركبات بريميوم' },
  trustExpertise: { en: 'Chauffeur expertise', ar: 'خبرة في خدمة السائقين' },
  trustSince: { en: 'Since 1990', ar: 'منذ 1990' },

  // Steps
  stepDuration: { en: 'Duration', ar: 'المدة' },
  stepTrip: { en: 'Trip Details', ar: 'تفاصيل الرحلة' },
  stepVehicle: { en: 'Vehicle', ar: 'المركبة' },
  stepConfirm: { en: 'Confirm', ar: 'التأكيد' },

  // Duration step
  durTitle: { en: 'Select Your Duration', ar: 'اختر المدة' },
  durSub: { en: 'Choose between a half-day or full-day chauffeur experience', ar: 'اختر بين تجربة نصف يوم أو يوم كامل مع سائق خاص' },
  durHalfTitle: { en: 'Half Day', ar: 'نصف يوم' },
  durHalfSub: { en: '4 Hours', ar: '4 ساعات' },
  durHalfDesc: { en: 'Ideal for airport transfers, business meetings, or city tours', ar: 'مثالي لنقل المطارات واجتماعات العمل والجولات داخل المدينة' },
  durFullTitle: { en: 'Full Day', ar: 'يوم كامل' },
  durFullSub: { en: '8 Hours', ar: '8 ساعات' },
  durFullDesc: { en: 'Perfect for events, multi-stop itineraries, or all-day availability', ar: 'مثالي للفعاليات والرحلات متعددة المحطات أو التوفر طوال اليوم' },
  from: { en: 'From', ar: 'ابتداءً من' },

  // Trip details
  tripTitle: { en: 'Trip Details', ar: 'تفاصيل الرحلة' },
  tripSub: { en: 'When and where would you like to be picked up?', ar: 'متى وأين ترغب أن نقلّك؟' },
  pickupDate: { en: 'Pickup Date *', ar: 'تاريخ الانطلاق *' },
  pickupTime: { en: 'Pickup Time *', ar: 'وقت الانطلاق *' },
  selectDate: { en: 'Select date', ar: 'اختر التاريخ' },
  selectTime: { en: 'Select time', ar: 'اختر الوقت' },
  pickupLocation: { en: 'Pickup Location *', ar: 'موقع الانطلاق *' },
  dropoffLocation: { en: 'Drop-off Location *', ar: 'موقع الوصول *' },
  address: { en: 'Address', ar: 'عنوان' },
  airport: { en: 'Airport', ar: 'مطار' },
  selectTerminal: { en: 'Select airport terminal', ar: 'اختر مبنى المطار' },
  pickupAddrPh: { en: 'e.g., Emirates Towers, Sheikh Zayed Road', ar: 'مثال: أبراج الإمارات، شارع الشيخ زايد' },
  dropoffAddrPh: { en: 'e.g., Dubai Mall, Downtown Dubai', ar: 'مثال: دبي مول، وسط مدينة دبي' },

  // Vehicle step
  vehTitle: { en: 'Choose Your Vehicle', ar: 'اختر مركبتك' },
  vehSub: { en: 'Select passengers to see recommended luxury vehicles', ar: 'اختر عدد الركاب لعرض المركبات الفاخرة المقترحة' },
  numPassengers: { en: 'Number of Passengers *', ar: 'عدد الركاب *' },
  upTo3: { en: 'Up to 3', ar: 'حتى 3' },
  upTo4: { en: 'Up to 4', ar: 'حتى 4' },
  upTo6: { en: 'Up to 6', ar: 'حتى 6' },
  passSedan: { en: 'Sedan', ar: 'سيدان' },
  passPremium: { en: 'Premium Sedan', ar: 'سيدان بريميوم' },
  passSuvVan: { en: 'SUV / Van', ar: 'دفع رباعي / فان' },

  // Confirm step + summary
  confirmTitle: { en: 'Confirm Your Booking', ar: 'أكّد حجزك' },
  confirmSub: { en: 'Review your trip details and provide your contact information', ar: 'راجع تفاصيل رحلتك وأدخل بيانات التواصل' },
  yourDetails: { en: 'Your Details', ar: 'بياناتك' },
  fullName: { en: 'Full Name *', ar: 'الاسم الكامل *' },
  email: { en: 'Email *', ar: 'البريد الإلكتروني *' },
  phone: { en: 'Phone *', ar: 'الهاتف *' },
  mobile971: { en: 'Mobile (+971) *', ar: 'الجوال (+971) *' },
  specialRequests: { en: 'Special Requests', ar: 'طلبات خاصة' },
  namePh: { en: 'John Smith', ar: 'محمد أحمد' },
  emailPh: { en: 'name@company.com', ar: 'name@company.com' },
  phonePh: { en: '+971 50 XXX XXXX', ar: '+971 50 XXX XXXX' },
  notesPhConfirm: { en: 'Child seat, extra luggage, specific route preferences...', ar: 'مقعد أطفال، أمتعة إضافية، تفضيلات مسار محددة...' },
  notesPhManaged: { en: 'Meet & greet, child seat, extra luggage, route preferences...', ar: 'استقبال وترحيب، مقعد أطفال، أمتعة إضافية، تفضيلات المسار...' },
  bookingSummary: { en: 'Booking Summary', ar: 'ملخص الحجز' },
  sumDuration: { en: 'Duration', ar: 'المدة' },
  sumDate: { en: 'Date', ar: 'التاريخ' },
  sumTime: { en: 'Time', ar: 'الوقت' },
  sumPickup: { en: 'Pickup', ar: 'الانطلاق' },
  sumDropoff: { en: 'Drop-off', ar: 'الوصول' },
  sumVehicle: { en: 'Vehicle', ar: 'المركبة' },
  sumPassengers: { en: 'Passengers', ar: 'الركاب' },
  half4h: { en: 'Half Day (4h)', ar: 'نصف يوم (4 ساعات)' },
  full8h: { en: 'Full Day (8h)', ar: 'يوم كامل (8 ساعات)' },
  half4hFull: { en: 'Half Day (4 Hours)', ar: 'نصف يوم (4 ساعات)' },
  full8hFull: { en: 'Full Day (8 Hours)', ar: 'يوم كامل (8 ساعات)' },
  baseFare: { en: 'Base fare', ar: 'السعر الأساسي' },
  vat5: { en: 'VAT (5%)', ar: 'ضريبة القيمة المضافة (5%)' },
  total: { en: 'Total', ar: 'الإجمالي' },

  // Vehicle card
  hours4: { en: '4 Hours', ar: '4 ساعات' },
  hours8: { en: '8 Hours', ar: '8 ساعات' },
  inclVat: { en: 'incl. VAT', ar: 'شامل الضريبة' },

  // Confirmation
  bookingReceived: { en: 'Booking Received', ar: 'تم استلام الحجز' },
  thankYouChauffeur: { en: F((name) => `Thank you, ${name}. Our concierge team will confirm your chauffeur booking within 2 hours.`), ar: F((name) => `شكراً لك، ${name}. سيؤكّد فريق الكونسيرج حجز سائقك الخاص خلال ساعتين.`) },
  thankYouManaged: { en: F((name) => `Thank you, ${name}. Our reservations team will confirm within 2 hours.`), ar: F((name) => `شكراً لك، ${name}. سيؤكّد فريق الحجوزات خلال ساعتين.`) },
  reference: { en: 'Reference', ar: 'المرجع' },
  bookAnotherRide: { en: 'Book Another Ride', ar: 'احجز رحلة أخرى' },
  bookAnother: { en: 'Book Another', ar: 'احجز حجزاً آخر' },

  // Managed parts / estimate
  returnTrip: { en: 'Return trip', ar: 'رحلة ذهاب وعودة' },
  fareEstimate: { en: 'Fare Estimate', ar: 'تقدير السعر' },
  estimateEmpty: { en: 'Select your route and vehicle to see an instant fare estimate.', ar: 'اختر المسار والمركبة لعرض تقدير فوري للسعر.' },
  estimatedTotal: { en: 'Estimated Total', ar: 'الإجمالي التقديري' },
  requestBooking: { en: 'Request Booking', ar: 'اطلب الحجز' },
  estimateFooter: { en: 'Estimate is indicative and inclusive of 5% VAT. Final quote confirmed by our team.', ar: 'التقدير استرشادي وشامل ضريبة 5%. يؤكّد فريقنا السعر النهائي.' },
  reservations247: { en: '24/7 Reservations & Assistance', ar: 'الحجوزات والمساعدة على مدار الساعة' },

  // Transfer booking
  modeAirport: { en: 'Airport Transfer', ar: 'نقل المطار' },
  modeCity: { en: 'City Point-to-Point', ar: 'داخل المدينة من نقطة إلى نقطة' },
  airportLabel: { en: 'Airport *', ar: 'المطار *' },
  selectAirport: { en: 'Select airport', ar: 'اختر المطار' },
  destZone: { en: 'Destination Zone *', ar: 'منطقة الوصول *' },
  selectArea: { en: 'Select area', ar: 'اختر المنطقة' },
  pickupArea: { en: 'Pickup Area *', ar: 'منطقة الانطلاق *' },
  dropoffArea: { en: 'Drop-off Area *', ar: 'منطقة الوصول *' },
  fromPh: { en: 'From', ar: 'من' },
  toPh: { en: 'To', ar: 'إلى' },
  vehicleClass: { en: 'Vehicle Class *', ar: 'فئة المركبة *' },
  flightOptional: { en: 'Flight Number (optional)', ar: 'رقم الرحلة (اختياري)' },
  flightPh: { en: 'e.g. EK 502', ar: 'مثال: EK 502' },
  transferNote: { en: 'Rates include fuel, Salik tolls and full insurance. Airport arrival transfers include a AED 40 parking & coordination fee. Terminal 2 pickups add AED 50.', ar: 'تشمل الأسعار الوقود ورسوم سالك والتأمين الشامل. تشمل رحلات الوصول من المطار رسوم مواقف وتنسيق قدرها 40 درهماً. الاستقبال من المبنى 2 يُضاف عليه 50 درهماً.' },
  airportParking: { en: 'Airport parking & coordination', ar: 'رسوم مواقف وتنسيق المطار' },
  returnWord: { en: 'return', ar: 'ذهاب وعودة' },
  returnSuffix: { en: ' · Return', ar: ' · ذهاب وعودة' },
  routeWord: { en: 'Route', ar: 'المسار' },
  coachWord: { en: 'Coach', ar: 'الحافلة' },

  // Bus booking
  tripAirport: { en: 'Airport Transfer', ar: 'نقل المطار' },
  tripHalfday: { en: 'Half Day (6 hrs)', ar: 'نصف يوم (6 ساعات)' },
  tripFullday: { en: 'Full Day (12 hrs)', ar: 'يوم كامل (12 ساعة)' },
  destination: { en: 'Destination *', ar: 'الوجهة *' },
  routeLabel: { en: 'Route *', ar: 'المسار *' },
  select: { en: 'Select', ar: 'اختر' },
  busType: { en: 'Bus / Coach Type *', ar: 'نوع الحافلة / الكوتش *' },
  busNote: { en: 'Rates include Salik tolls, insurance and fuel. Airport arrival parking (AED 150–250) and RTA emirate permits (AED 250 for SHJ/AJM/RAK/FUJ) are charged as actual. Minimum 72 hours advance booking.', ar: 'تشمل الأسعار رسوم سالك والتأمين والوقود. تُحتسب مواقف الوصول للمطار (150–250 درهماً) وتصاريح هيئة الطرق للإمارات (250 درهماً للشارقة/عجمان/رأس الخيمة/الفجيرة) كما هي فعلياً. الحد الأدنى للحجز 72 ساعة مسبقاً.' },

  // Validation
  errZone: { en: 'Select a destination zone', ar: 'اختر منطقة الوصول' },
  errFrom: { en: 'Select a pickup area', ar: 'اختر منطقة الانطلاق' },
  errTo: { en: 'Select a drop-off area', ar: 'اختر منطقة الوصول' },
  errToDiff: { en: 'Pickup and drop-off must differ', ar: 'يجب أن تختلف منطقة الانطلاق عن الوصول' },
  errRoute: { en: 'Route not tariffed — please contact us for a quote', ar: 'المسار غير مُسعّر — يرجى التواصل معنا للحصول على عرض سعر' },
  errVehicleClass: { en: 'Select a vehicle class', ar: 'اختر فئة المركبة' },
  errBus: { en: 'Select a bus type', ar: 'اختر نوع الحافلة' },
  errDest: { en: 'Select a route', ar: 'اختر مساراً' },
  errDate: { en: 'Select a date', ar: 'اختر تاريخاً' },
  errTime: { en: 'Select a time', ar: 'اختر وقتاً' },
  errName: { en: 'Full name is required', ar: 'الاسم الكامل مطلوب' },
  errEmail: { en: 'Valid email is required', ar: 'بريد إلكتروني صحيح مطلوب' },
  errPhone: { en: 'Phone number is required', ar: 'رقم الهاتف مطلوب' },
  errDuration: { en: 'Please select a duration', ar: 'يرجى اختيار المدة' },
  errPassengers: { en: 'Select number of passengers', ar: 'اختر عدد الركاب' },
  errVehicle: { en: 'Please select a vehicle', ar: 'يرجى اختيار مركبة' },
  errSelectTerminal: { en: 'Select airport terminal', ar: 'اختر مبنى المطار' },
  errPickupAddr: { en: 'Enter pickup address', ar: 'أدخل عنوان الانطلاق' },
  errDropoffAddr: { en: 'Enter drop-off address', ar: 'أدخل عنوان الوصول' },
  submitFallback: { en: 'We could not submit your booking right now. Please try again or call 800 364.', ar: 'تعذّر إرسال حجزك الآن. يرجى المحاولة مرة أخرى أو الاتصال على 800 364.' },
};

export function bt(lang, key, ...args) {
  const entry = DICT[key];
  if (!entry) return key;
  const val = entry[lang] || entry.en;
  return typeof val === 'function' ? val(...args) : val;
}

const CLASS_AR = {
  'Executive Sedan': 'سيدان تنفيذي', 'Compact SUV': 'دفع رباعي مدمج', 'Luxury SUV (7-Seat)': 'دفع رباعي فاخر (7 مقاعد)',
  'Executive Van (7-Seat)': 'فان تنفيذي (7 مقاعد)', 'Executive Van': 'فان تنفيذي', 'First Class Sedan': 'سيدان درجة أولى',
  'Premium Sedan': 'سيدان بريميوم', 'Large SUV': 'دفع رباعي كبير', 'Electric Luxury': 'كهربائية فاخرة',
  'Premium SUV': 'دفع رباعي بريميوم', 'Executive SUV': 'دفع رباعي تنفيذي', 'Luxury Van': 'فان فاخر',
};
const BADGE_AR = {
  'Most Popular': 'الأكثر طلباً', 'Premium Class': 'الفئة البريميوم', 'Airport & Groups': 'المطار والمجموعات', 'VIP': 'كبار الشخصيات',
};
const FEATURE_AR = {
  'Leather interior': 'مقصورة جلدية', 'Climate control': 'تحكم بالمناخ', 'Complimentary water': 'مياه مجانية',
  'Zero emissions': 'انبعاثات صفرية', 'Panoramic roof': 'سقف بانورامي', 'Premium sound': 'صوت بريميوم',
  'Quattro AWD': 'دفع رباعي كواترو', 'Bang & Olufsen audio': 'نظام صوت Bang & Olufsen', 'Ambient lighting': 'إضاءة محيطة',
  'Captain seats': 'مقاعد كابتن', 'Rear climate zone': 'منطقة مناخ خلفية', 'Privacy glass': 'زجاج عازل للرؤية',
  'Full-size luxury': 'فخامة كاملة الحجم', 'Third-row seating': 'صف مقاعد ثالث', 'Premium leather': 'جلد بريميوم',
  'Extended cabin': 'مقصورة ممتدة', 'Spacious interior': 'مقصورة واسعة', 'Advanced safety': 'أنظمة أمان متقدمة',
};

export const vehClass = (lang, name) => (lang === 'ar' ? CLASS_AR[name] || name : name);
export const badgeT = (lang, b) => (lang === 'ar' && b ? BADGE_AR[b] || b : b);
export const featureT = (lang, f) => (lang === 'ar' ? FEATURE_AR[f] || f : f);
export const paxLabel = (lang, s) => {
  if (lang !== 'ar' || !s) return s;
  return s.replace('Up to', 'حتى').replace('passengers', 'راكب').replace('passenger', 'راكب').replace('bags', 'حقيبة').replace('bag', 'حقيبة');
};
export const seatLabel = (lang, s) => (lang !== 'ar' || !s ? s : s.replace('-seat', ' مقعد'));

const TRANSFER_TERMS_AR = [
  'الأسعار بالدرهم الإماراتي، صافية وغير قابلة للعمولة، وتشمل الوقود ورسوم سالك ورسوم مواقف مطار دبي والتأمين الشامل.',
  'يجب إجراء جميع الحجوزات قبل 12 ساعة على الأقل.',
  'لاستقبال المطار (المباني 1 و2 و3)، يُرجى من الضيوف التواصل مع مكتب يوروبكار في المطار لخدمة الاستقبال والترحيب.',
  'الاستقبال / التوصيل من مبنى المطار 2 يُضاف عليه 50 درهماً.',
  'أقصى مدة انتظار لرحلات المغادرة 15 دقيقة؛ بعدها يُعامل الحجز كعدم حضور ويُحتسب بالكامل.',
  'حالات عدم الحضور والإلغاء قبل أقل من 6 ساعات من الانطلاق تُحتسب بالكامل حسب التعرفة.',
  'سعر اليوم الكامل يشمل 400 كم مجاناً يومياً؛ ويُحتسب الكيلومتر الإضافي بدرهم واحد لكل كم.',
  'تُطبّق رسوم مواقف وتنسيق قدرها 40 درهماً على جميع رحلات الوصول من المطار.',
  'تُطبّق ضريبة القيمة المضافة 5% على جميع الرسوم.',
];

const BUS_TERMS_AR = [
  'الأسعار بالدرهم الإماراتي، صافية وغير قابلة للعمولة، وتشمل رسوم سالك والتأمين الشامل وتكلفة الوقود.',
  'تتطلب جميع الحجوزات إشعاراً مسبقاً لا يقل عن 72 ساعة.',
  'تُحتسب رسوم مواقف الوصول كما هي فعلياً — 250 درهماً + ضريبة لكل وصول (150 درهماً لحافلات 12 مقعداً).',
  'تتطلب الرحلات إلى الشارقة وعجمان ورأس الخيمة والفجيرة تصريح هيئة الطرق للإمارة المعنية، ويُحتسب بمبلغ 250 درهماً.',
  'رسوم مواقف مطار دبي عند الوصول: 250 درهماً لحافلات 50/34/22 مقعداً، و150 درهماً لحافلات 12 مقعداً. مطار أبوظبي: 50 درهماً/ساعة لجميع الحافلات.',
  'فترة السماح عند الوصول للمطار محدودة بـ 45 دقيقة؛ ويُحتسب الوقت الزائد وفقاً لذلك.',
  'أقصى مسافة مجانية لتأجير 12 ساعة هي 300 كم داخل دبي و400 كم لبقية الإمارات؛ ويُحتسب الكيلومتر الإضافي بـ 3 دراهم لكل كم.',
  'ينطبق تأجير نصف اليوم (6 ساعات) داخل حدود مدينتي دبي والشارقة فقط.',
  'بدل مبيت السائق 400 درهم لكل ليلة.',
  'لا تنطبق الأسعار في تواريخ الحظر (مثل معرض دبي للطيران، وفورمولا 1 أبوظبي، وكأس دبي العالمي).',
  'الإلغاء قبل 24 ساعة أو أكثر من الحجز مجاني؛ وقبل 12–24 ساعة يُحتسب 50%.',
  'تُطبّق ضريبة القيمة المضافة 5% على جميع الرسوم.',
];

export const getTerms = (lang, service, enTransfer, enBus) => {
  if (lang === 'ar') return service === 'bus' ? BUS_TERMS_AR : TRANSFER_TERMS_AR;
  return service === 'bus' ? enBus : enTransfer;
};
